import React from 'react';
import PropTypes from 'prop-types';
import NewDialog from 'Components/UI/ConfirmationDialog/NewDialog';

const ThreadParticipantRemovalConfirmationDialog = ({
  confirmMember,
  loading,
  handleConfirm,
  handleClose,
  handleConfirmationClose,
}) => {
  return (
    <NewDialog
      title={'Are you sure?'}
      message={`You are about to remove ${confirmMember.attr('name')} from this thread.`}
      cancelLabel={'Nevermind'}
      confirmLabel={'Remove'}
      confirmButtonType="error"
      loading={loading}
      onConfirm={async () => {
        await handleConfirm(confirmMember);
        handleConfirmationClose();
      }}
      onCancel={() => {
        handleClose();
        handleConfirmationClose();
      }}
      onClose={() => {
        handleClose();
        handleConfirmationClose();
      }}
      showCloseIcon={false}
    />
  );
};

ThreadParticipantRemovalConfirmationDialog.defaultProps = {
};

ThreadParticipantRemovalConfirmationDialog.propTypes = {
  confirmMember: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirmationClose: PropTypes.func.isRequired,
};

export { ThreadParticipantRemovalConfirmationDialog };
